document.querySelector('.menu-toggle').addEventListener('click', function() {
    this.classList.toggle('active');
    document.querySelector('.page-header').classList.toggle('header-active');
    document.querySelector('.js-ph-mobile').classList.toggle('nav-open');
    document.body.classList.toggle('body-overflow');
});

document.querySelector('.js-ph-mobile-close').addEventListener('click', function() {
    document.querySelector('.menu-toggle').classList.remove('active');
    document.querySelector('.page-header').classList.remove('header-active');
    document.querySelector('.js-ph-mobile').classList.remove('nav-open');
    document.body.classList.remove('body-overflow');
});